module.exports = __webpack_public_path__ + "img/3ds.5f323755.svg";